import React, { Component } from "react";

class Home extends Component {
  constructor() {
    super();
    this.state = {
      numberApprovals: 0,
      numberCashes: 0,
      numberTransfers: 0,
      permission: [],
    };
    this.fireRedirect = this.fireRedirect.bind(this);
    this.handleRedirect = this.handleRedirect.bind(this);
  }

  componentDidMount() {
    //Count approval
    axios.get("/api/approvals").then((response) => {
      this.setState({
        numberApprovals: response.data.length,
      });
    });
    //Count approval
    axios.get("/api/cashes/count/0").then((response) => {
      this.setState({
        numberCashes:
          !isNaN(+response.data) && isFinite(response.data) ? response.data : 0,
      });
    });
    //Count approval
    // axios.get('/api/transfer-request/count/4').then(response => {
    //     this.setState({
    //         numberTransfers: (!isNaN(+response.data) && isFinite(response.data)) ? response.data : 0
    //     });
    // });
    //Get permission
    axios.get("/api/check-permissions").then((response) => {
      this.setState({
        permission: response.data,
      });
    });
  }

  handleRedirect(url) {
    this.props.history.push(url);
  }

  fireRedirect(e) {
    e.preventDefault();
    this.handleRedirect(e.currentTarget.getAttribute("href"));
  }

  /**
   * Handle hover image
   */
  onHoverTooltip() {
    $('[data-toggle="tooltip"]').tooltip();
  }

  render() {
    return (
      <div>
        <div className="row">
          <div className="col-sm-12">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item active" aria-current="page">
                  ダッシュボード
                </li>
              </ol>
            </nav>
          </div>
        </div>
        <main id="main" onMouseOver={this.onHoverTooltip}>
          <div className="row mb-5">
            <div className="col-sm-12">
              <div className="card-deck">
                {this.state.permission.includes("/") ||
                this.state.permission.includes("/temporary-regists") ? (
                  <div className="card">
                    <a onClick={this.fireRedirect} href="/temporary-regists">
                      <div className="card-body p-5 text-center bg-cyan text-white">
                        <i className="material-icons md-48 mx-auto d-block mb-3">
                          people
                        </i>
                        <strong className="card-title">仮登録者一覧</strong>
                        <p className="mb-0">
                          仮登録者の一覧を
                          <br />
                          管理します
                        </p>
                      </div>
                    </a>
                  </div>
                ) : (
                  ""
                )}
                {this.state.permission.includes("/") ||
                this.state.permission.includes("/accounts") ? (
                  <div className="card">
                    <a onClick={this.fireRedirect} href="/accounts">
                      <div className="card-body p-5 text-center bg-purple text-white">
                        <i className="material-icons md-48 mx-auto d-block mb-3">
                          record_voice_over
                        </i>
                        <strong className="card-title">登録者一覧</strong>
                        <p className="mb-0">
                          全ての登録者の情報を
                          <br />
                          管理します
                        </p>
                      </div>
                    </a>
                  </div>
                ) : (
                  ""
                )}
                {/* {this.state.permission.includes("/") ||
                this.state.permission.includes("/clients") ? (
                  <div className="card">
                    <a onClick={this.fireRedirect} href="/clients">
                      <div className="card-body p-5 text-center bg-pink text-white">
                        <i className="material-icons md-48 mx-auto d-block mb-3">
                          people_outline
                        </i>
                        <strong className="card-title">依頼者一覧</strong>
                        <p className="mb-0">
                          登録している依頼者を
                          <br />
                          管理します
                        </p>
                      </div>
                    </a>
                  </div>
                ) : (
                  ""
                )}
                {this.state.permission.includes("/") ||
                this.state.permission.includes("/staffs") ? (
                  <div className="card">
                    <a onClick={this.fireRedirect} href="/staffs">
                      <div className="card-body p-5 text-center bg-cyan text-white">
                        <i className="material-icons md-48 mx-auto d-block mb-3">
                          people
                        </i>
                        <strong className="card-title">ワーカー一覧</strong>
                        <p className="mb-0">
                          登録してるワーカーを
                          <br />
                          管理します
                        </p>
                      </div>
                    </a>
                  </div>
                ) : (
                  ""
                )} */}
                {this.state.permission.includes("/") ||
                this.state.permission.includes("/jobs") ? (
                  <div className="card">
                    <a onClick={this.fireRedirect} href="/jobs">
                      <div className="card-body p-5 text-center bg-pink text-white">
                        <i className="material-icons md-48 mx-auto d-block mb-3">
                          assignment
                        </i>
                        <strong className="card-title">依頼一覧</strong>
                        <p className="mb-0">
                          お仕事の依頼の一覧を
                          <br />
                          管理します
                        </p>
                      </div>
                    </a>
                  </div>
                ) : (
                  ""
                )}
                {this.state.permission.includes("/") ||
                this.state.permission.includes("/jobapplys") ? (
                  <div className="card">
                    <a onClick={this.fireRedirect} href="/jobapplys">
                      <div className="card-body p-5 text-center bg-cyan text-white">
                        <i className="material-icons md-48 mx-auto d-block mb-3">
                          assignment_ind
                        </i>
                        <strong className="card-title">応募一覧</strong>
                        <p className="mb-0">
                          お仕事の応募の一覧を
                          <br />
                          管理します
                        </p>
                      </div>
                    </a>
                  </div>
                ) : (
                  ""
                )}
                <div className="col" />
              </div>
            </div>
          </div>
          <div className="row mb-5">
            <div className="col-sm-12">
              <div className="card-deck">
                {this.state.permission.includes("/") ||
                this.state.permission.includes("/points") ? (
                  <div className="card bg-purple text-white">
                    <a onClick={this.fireRedirect} href="/points">
                      <div className="card-body p-5 text-center">
                        <i className="material-icons md-48 mx-auto d-block mb-3">
                          control_point
                        </i>
                        <strong className="card-title">報酬履歴</strong>
                        <p className="mb-0 <!--d-none d-sm-inline-->">
                          シェアジョブのサービス全体の金額を管理します
                        </p>
                      </div>
                    </a>
                  </div>
                ) : (
                  ""
                )}
                {this.state.permission.includes("/") ||
                this.state.permission.includes("/cashes") ? (
                  <div className="card bg-cyan text-white">
                    <a onClick={this.fireRedirect} href="/cashes">
                      {this.state.numberCashes != 0 ? (
                        <span
                          className="notification notification-warning"
                          data-toggle="tooltip"
                          data-placement="bottom"
                          title="未送金数"
                        >
                          {this.state.numberCashes}
                        </span>
                      ) : (
                        ""
                      )}
                      <div className="card-body p-5 text-center">
                        <i className="material-icons md-48 mx-auto d-block mb-3">
                          transform
                        </i>
                        <strong className="card-title">現金申請</strong>
                        <p className="mb-0">
                          ワーカーからの現金申請を一覧表示します
                        </p>
                      </div>
                    </a>
                  </div>
                ) : (
                  ""
                )}
                {this.state.permission.includes("/") ||
                this.state.permission.includes("/transfers") ? (
                  <div className="card bg-cyan text-white">
                    <a onClick={this.fireRedirect} href="/transfers">
                      {this.state.numberTransfers != 0 ? (
                        <span
                          className="notification notification-warning"
                          data-toggle="tooltip"
                          data-placement="bottom"
                          title="未送金数"
                        >
                          {this.state.numberTransfers}
                        </span>
                      ) : (
                        ""
                      )}
                      <div className="card-body p-5 text-center">
                        <i className="material-icons md-48 mx-auto d-block mb-3">
                          transform
                        </i>
                        <strong className="card-title">銀行振込申請</strong>
                        <p className="mb-0">
                          ワーカーからの銀行振込申請を一覧表示します
                        </p>
                      </div>
                    </a>
                  </div>
                ) : (
                  ""
                )}
                {this.state.permission.includes("/") ||
                this.state.permission.includes("/messages") ? (
                  <div className="card bg-purple text-white">
                    <a onClick={this.fireRedirect} href="/messages">
                      <div className="card-body p-5 text-center">
                        <i className="material-icons md-48 mx-auto d-block mb-3">
                          message
                        </i>
                        <strong className="card-title">コメント履歴</strong>
                        <p className="mb-0 <!--d-none d-sm-inline-->">
                          応募者ごとのコメント一覧を表示します
                        </p>
                      </div>
                    </a>
                  </div>
                ) : (
                  ""
                )}
                {this.state.permission.includes("/") ||
                this.state.permission.includes("/mails") ? (
                  <div className="card bg-purple text-white">
                    <a onClick={this.fireRedirect} href="/mails">
                      <div className="card-body p-5 text-center">
                        <i className="material-icons md-48 mx-auto d-block mb-3">
                          mail
                        </i>
                        <strong className="card-title">メール配信</strong>
                        <p className="mb-0 <!--d-none d-sm-inline-->">
                          依頼者・ワーカーへメールを一斉配信します
                        </p>
                      </div>
                    </a>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
          <div className="row mb-5">
            <div className="col-sm-12">
              <div className="card-deck">
                {this.state.permission.includes("/") ||
                this.state.permission.includes("/tickets") ? (
                  <div className="card">
                    <a onClick={this.fireRedirect} href="/tickets">
                      <div className="card-body p-5 text-center bg-pink text-white">
                        <i className="material-icons md-48 mx-auto d-block mb-3">
                          assignment
                        </i>
                        <strong className="card-title">チケット一覧</strong>
                        <p className="mb-0">
                          助っ人のチケット一覧を
                          <br />
                          管理します
                        </p>
                      </div>
                    </a>
                  </div>
                ) : (
                  ""
                )}
                {this.state.permission.includes("/") ||
                this.state.permission.includes("/ticketrequests") ? (
                  <div className="card">
                    <a onClick={this.fireRedirect} href="/ticketrequests">
                      <div className="card-body p-5 text-center bg-cyan text-white">
                        <i className="material-icons md-48 mx-auto d-block mb-3">
                          assignment_ind
                        </i>
                        <strong className="card-title">チケット申込み一覧</strong>
                        <p className="mb-0">
                          チケットへの申込みの一覧を
                          <br />
                          管理します
                        </p>
                      </div>
                    </a>
                  </div>
                ) : (
                  ""
                )}
                {this.state.permission.includes("/") ||
                    this.state.permission.includes("/chats") ? (
                      <div className="card bg-purple text-white">
                        <a onClick={this.fireRedirect} href="/chats">
                          <div className="card-body p-5 text-center">
                            <i className="material-icons md-48 mx-auto d-block mb-3">
                              message
                            </i>
                            <strong className="card-title">チャット履歴</strong>
                            <p className="mb-0 <!--d-none d-sm-inline-->">
                              助っ人のチャット一覧を表示します
                            </p>
                          </div>
                        </a>
                      </div>
                    ) : (
                      ""
                    )
                }
                <div className="col" />
                <div className="col" />
              </div>
            </div>
          </div>
          <div className="row mb-5">
            <div className="col-sm-12">
              <div className="card-deck">
                {this.state.permission.includes("/") ||
                this.state.permission.includes("/users") ? (
                  <div className="card">
                    <a onClick={this.fireRedirect} href="/users">
                      <div className="card-body p-5 text-center">
                        <i className="material-icons md-48 mx-auto d-block mb-3">
                          supervisor_account
                        </i>
                        <strong className="card-title">社内ユーザー一覧</strong>
                        <p className="mb-0">
                          社内で利用するユーザーを
                          <br />
                          設定します
                        </p>
                      </div>
                    </a>
                  </div>
                ) : (
                  ""
                )}
                {this.state.permission.includes("/") ||
                this.state.permission.includes("/roles") ? (
                  <div className="card">
                    <a onClick={this.fireRedirect} href="/roles">
                      <div className="card-body p-5 text-center">
                        <i className="material-icons md-48 mx-auto d-block mb-3">
                          style
                        </i>
                        <strong className="card-title">ロール一覧</strong>
                        <p className="mb-0">
                          社内で利用するユーザーの
                          <br />
                          ロールを設定します
                        </p>
                      </div>
                    </a>
                  </div>
                ) : (
                  ""
                )}
                {this.state.permission.includes("/") ||
                this.state.permission.includes("/permissions") ? (
                  <div className="card">
                    <a onClick={this.fireRedirect} href="/permissions">
                      <div className="card-body p-5 text-center">
                        <i className="material-icons md-48 mx-auto d-block mb-3">
                          verified_user
                        </i>
                        <strong className="card-title">権限一覧</strong>
                        <p className="mb-0">
                          社内で利用するユーザーの
                          <br />
                          権限を設定します
                        </p>
                      </div>
                    </a>
                  </div>
                ) : (
                  ""
                )}
                {this.state.permission.includes("/") ||
                this.state.permission.includes("/menus") ? (
                  <div className="card">
                    <a onClick={this.fireRedirect} href="/menus">
                      <div className="card-body p-5 text-center">
                        <i className="material-icons md-48 mx-auto d-block mb-3">
                          view_module
                        </i>
                        <strong className="card-title">メニュー一覧</strong>
                        <p className="mb-0">
                          管理画面の中で利用する
                          <br />
                          URLを設定します
                        </p>
                      </div>
                    </a>
                  </div>
                ) : (
                  ""
                )}
                {this.state.permission.includes("/") ? (
                  <div className="card">
                    <a onClick={this.fireRedirect} href="/ngwords">
                      <div className="card-body p-5 text-center">
                        <i className="material-icons md-48 mx-auto d-block mb-3">
                          notification_important
                        </i>
                        <strong className="card-title">NGワード一覧</strong>
                        <p className="mb-0">
                          依頼備考欄・コメント一覧の中で利用する
                          <br />
                          NGワードを設定します
                        </p>
                      </div>
                    </a>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
          {/*
          <div className="row mb-5">
            <div className="col-sm-12">
              <div className="card-deck">
                {this.state.permission.includes("/") ||
                this.state.permission.includes("/houjin_users") ? (
                  <div className="card">
                    <a onClick={this.fireRedirect} href="/houjin_users">
                      <div className="card-body p-5 text-center">
                        <i className="material-icons md-48 mx-auto d-block mb-3">
                          supervised_user_circle
                        </i>
                        <strong className="card-title">
                          法人アカウント一覧
                        </strong>
                        <p className="mb-0">
                          法人の利用する
                          <br />
                          アカウントを設定します
                        </p>
                      </div>
                    </a>
                  </div>
                ) : (
                  ""
                )}
                <div className="col" />
                <div className="col" />
                <div className="col" />
                <div className="col" />
              </div>
            </div>
          </div>
          */}
        </main>
      </div>
    );
  }
}
export default Home;
